export default "__VITE_ASSET__CFivWdjB__"